import { Text } from "@clipboard-health/ui-components";
import { Button } from "@src/appV2/redesign/components/Button";
import { BaseTierCard } from "@src/appV2/redesign/Tiers/Cards/BaseTierCard";
import { LimitedTierCardWrapper } from "@src/appV2/redesign/Tiers/Cards/LimitedTierCardWrapper";
import { TIERS_FULL_PATH } from "@src/appV2/redesign/Tiers/paths";
import { TIERS_PERKS_SECTION_ID } from "@src/appV2/redesign/Tiers/utils/constants";
import { useHistory } from "react-router-dom";

export function LimitedTierHeaderSection() {
  const history = useHistory();

  return (
    <LimitedTierCardWrapper>
      <BaseTierCard
        title="Limited Access"
        content={
          <Text variant="body1" textAlign="left">
            Work your way up to Silver and unlock unlimited bookings!
          </Text>
        }
        footer={
          <Button
            invert
            variant="contained"
            size="medium"
            endIconType="chevron-right"
            sx={{ width: "fit-content" }}
            onClick={() => {
              history.replace(`${TIERS_FULL_PATH}#${TIERS_PERKS_SECTION_ID}`);
            }}
          >
            Learn More
          </Button>
        }
      />
    </LimitedTierCardWrapper>
  );
}
